// Each customer maps a URL namespace to the specific Order-N-Scan app.
//
// platform: which Order-N-Scan app to use for this customer's orders.
//   "ios"     - launch the customized native iOS app via universal link
//               (requires appIdentifier + appAddress).
//   "web"     - show the web-based Order-N-Scan app directly, no native app.
//   "android" - placeholder for the future Android app (not yet supported).
//
// If platform is omitted it defaults to "web".
export const customers = [
  {
    namespace: "xyken-test-ios",
    platform: "ios",
    appName: "SnugFit Order-N-Scan Demo",
    appIdentifier: "com.xyken.SnugFitLink",
    appAddress:
      "https://apps.apple.com/us/app/snugfit-o-p-3d-scanner/id1672649360",
  },
  {
    namespace: "xyken-test-web",
    platform: "web",
    appName: "SnugFit 3D Foot Scanner",
    labId: "m5Wb8PEEnD",
    fileFormats: ["stl"],
  },
  {
    namespace: "xyken-test-web-cc",
    platform: "web",
    appName: "SnugFit 3D Foot Scanner",
    labId: "HMyAszLp-T",
    fileFormats: ["stl", "obj"],
  },
  {
    namespace: "xyken-test-web-lb",
    platform: "web",
    appName: "SnugFit 3D Foot Scanner",
    labId: "dEeIMj7Cfz",
    fileFormats: ["stl"],
  },
  {
    namespace: "snugfit-test",
    platform: "web",
    appName: "SnugFit 3D Foot Scanner",
    labId: "xc8GKkifQM",
    fileFormats: ["stl"],
  },
  {
    namespace: "xyken-test-android",
    platform: "android",
    appName: "SnugFit Order-N-Scan Demo",
  },
  {
    namespace: "solo",
    platform: "ios",
    appName: "SOLO GO",
    appIdentifier: "com.xyken.SnugFitLink.Solo",
    appAddress:
      "https://apps.apple.com/us/app/solo-go-foot-scanner/id6476235722",
  },
  {
    namespace: "viso",
    platform: "ios",
    appName: "viSo ID3",
    appIdentifier: "com.xyken.SnugFitLink.viSo",
    appAddress: "https://apps.apple.com/us/app/solo-viso-id3/id6505079800",
  },
  {
    namespace: "feetid",
    platform: "ios",
    appName: "FEET iD",
    appIdentifier: "com.xyken.SnugFitLink.FEETiD",
    appAddress: "https://apps.apple.com/us/app/feet-id-scanner/id6736373688",
  },
  {
    namespace: "powderhouse",
    platform: "ios",
    appName: "Boot Solutions",
    appIdentifier: "com.xyken.SnugFitLink.BootSolutions",
    appAddress:
      "https://apps.apple.com/us/app/boot-solutions-3d-scanner/id6749552280",
  },
  {
    namespace: "ortho-revolution",
    platform: "ios",
    appName: "Orthotic 3D",
    appIdentifier: "com.xyken.SnugFitLink.OrthoticRevolution",
    appAddress:
      "https://apps.apple.com/us/app/orthotic-revolution-3d-scanner/id6749649748",
  },
  {
    namespace: "oolab",
    platform: "ios",
    appName: "3D CustomFit",
    appIdentifier: "com.xyken.SnugFitLink.oolab",
    appAddress: "https://apps.apple.com/us/app/3d-customfit/id6751545085",
  },
  {
    namespace: "foothub",
    platform: "ios",
    appName: "MYFOOTHUB",
    appIdentifier: "com.xyken.SnugFitLink.FootHub",
    appAddress:
      "https://apps.apple.com/us/app/myfoothub-3d-scanner/id6751515372",
  },
  {
    namespace: "stoked-steps",
    platform: "ios",
    appName: "Stoked Steps",
    appIdentifier: "com.xyken.SnugFitLink.StokedSteps",
    appAddress: "https://apps.apple.com/us/app/stoked-steps/id6793197651",
  },
  {
    namespace: "vivo",
    platform: "web",
    appName: "VivoBiome",
    labId: "B-riKm_JAv",
    fileFormats: ["stl"],
  },
  {
    namespace: "footid",
    platform: "web",
    appName: "FOOTID",
    labId: "onYVwToJJG",
    fileFormats: ["stl"],
  },
  {
    namespace: "heysoles",
    platform: "web",
    appName: "Heysoles",
    labId: "Hx3Q9yZsp6",
    fileFormats: ["stl"],
  },
];
